import { createComponent } from '@carvana/merch-components';
import React from 'react';

export default createComponent<React.HTMLProps<HTMLButtonElement>>('button', {
  className:
    'bg-transparent text-blue-2 hover:text-blue-3 -:inline -:w-fit -:p-0 -:text-left -:[font-size:inherit] -:[font-weight:inherit]'
});
